export enum RelayOperationTypeEnum {
    disabled = 0,
    input = 1,
    output = 2,
}
